"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductDocumentTypeTrads = void 0;
exports.EProductDocumentTypeTrads = {
    accord_conjoint_versement: "Attestation accord du conjoint versement de dividendes",
    bulletin_souscription: "Bulletin de souscription",
    bulletin_souscription_plus_75_ans: "Attestation pour les personnes de plus de 75 ans",
    bulletin_souscription_plus_80_ans: "Attestation pour les personnes de plus de 80 ans",
    bulletin_souscription_plus_85_ans: "Attestation pour les personnes de plus de 85 ans",
    mandat_sepa: "Mandat de prélèvement SEPA",
    appor_compte_courant_associe: "Attestation d'apport en compte courant d'associé",
    origine_fonds: "Attestation d'origine des fonds (DOF)",
    questionnaire_investisseur: "Questionnaire connaissance client / investisseur",
    remploi_fonds_propres: "Attestation de réemploi de fonds propres",
    forumulaire_facta: "Formulaire FATCA",
    rapport_special: "Rapport spécial",
    beneficiaires_effectifs: "Formulaire bénéficiaires effectifs",
    fiche_diligence: "Fiche de diligence",
    mscq: "MSQC",
    convention_indivision: "Convention d'indivision",
    personne_politiquement_exposee: "Attestation de personne politiquement exposée",
    renonciation_marie: "Attestation de renonciation du conjoint",
    renonciation_pacse: "Attestation de renonciation du partenaire pacsé",
};
